var _desc, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    height: 19,
    width: 19,
    id: "Whatsapp-Logo--Streamline-Logos.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Whatsapp Logo Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M17 16.5c-1.74 1.74 -5.749 0.257 -7.753 -1.747C7.243 12.749 5.76 8.74 7.5 7c0.504 -0.504 1.198 -0.564 1.622 -0.544 0.245 0.011 0.457 0.155 0.6 0.355l0.952 1.334a1 1 0 0 1 -0.107 1.288l-0.901 0.901c0.166 0.5 0.7 1.7 1.5 2.5s2 1.334 2.5 1.5l0.901 -0.9a1 1 0 0 1 1.288 -0.108l1.334 0.952c0.2 0.143 0.344 0.355 0.355 0.6 0.02 0.424 -0.04 1.118 -0.544 1.622Z",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M12 22.5c5.799 0 10.5 -4.701 10.5 -10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12c0 1.912 0.511 3.706 1.405 5.25l-0.88 4.725 4.725 -0.88A10.452 10.452 0 0 0 12 22.5Z",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.bfa8f014ff7851ea2846494c1b768307.svg";
export { ForwardRef as ReactComponent };